// =============================================================================
// 5. ConductSubstantiveTestingButton.js
// src/components/RPA/buttons/ConductSubstantiveTestingButton.js
// =============================================================================
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function ConductSubstantiveTestingButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [samplingMethod, setSamplingMethod] = useState('both');

  const handleClick = () => {
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/balance-sheet/conduct-substantive-testing`,
        { samplingMethod },
        { withCredentials: true }
      );
      
      console.log('[SUBSTANTIVE_TESTING_BTN] Success:', res.data);
      setShowModal(false);
      if (onDone) onDone();
    } catch (err) {
      console.error('[SUBSTANTIVE_TESTING_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Substantive testing failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading || !!disabledHint}
        title={disabledHint || 'Conduct substantive audit testing'}
        style={{
          background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#ec4899'),
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 11,
          cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: 500
        }}
      >
        {loading ? 'Testing…' : 'Substantive Testing'}
      </button>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 9999
        }}>
          <div style={{
            background: 'white', padding: 24, borderRadius: 12,
            maxWidth: 400, width: '90%', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: 16 }}>Conduct Substantive Testing</h3>
            <p style={{ margin: '0 0 16px 0', fontSize: 12, color: '#6b7280' }}>
              Select sampling methodology for material accounts:
            </p>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ 
                display: 'block', 
                marginBottom: 10, 
                fontSize: 14,
                padding: 10,
                border: '1px solid #e5e7eb',
                borderRadius: 6,
                cursor: 'pointer',
                background: samplingMethod === 'statistical' ? '#f0f9ff' : 'white'
              }}>
                <input
                  type="radio"
                  value="statistical"
                  checked={samplingMethod === 'statistical'}
                  onChange={(e) => setSamplingMethod(e.target.value)}
                  style={{ marginRight: 8 }}
                />
                <strong>Statistical Sampling</strong>
                <div style={{ fontSize: 11, color: '#6b7280', marginLeft: 20, marginTop: 2 }}>
                  Random selection with confidence levels and precision
                </div>
              </label>

              <label style={{ 
                display: 'block', 
                marginBottom: 10, 
                fontSize: 14,
                padding: 10,
                border: '1px solid #e5e7eb',
                borderRadius: 6,
                cursor: 'pointer',
                background: samplingMethod === 'judgmental' ? '#f0f9ff' : 'white'
              }}>
                <input
                  type="radio"
                  value="judgmental"
                  checked={samplingMethod === 'judgmental'}
                  onChange={(e) => setSamplingMethod(e.target.value)}
                  style={{ marginRight: 8 }}
                />
                <strong>Judgmental Sampling</strong>
                <div style={{ fontSize: 11, color: '#6b7280', marginLeft: 20, marginTop: 2 }}>
                  Auditor-selected items based on risk assessment
                </div>
              </label>

              <label style={{ 
                display: 'block', 
                fontSize: 14,
                padding: 10,
                border: '1px solid #e5e7eb',
                borderRadius: 6,
                cursor: 'pointer',
                background: samplingMethod === 'both' ? '#f0f9ff' : 'white'
              }}>
                <input
                  type="radio"
                  value="both"
                  checked={samplingMethod === 'both'}
                  onChange={(e) => setSamplingMethod(e.target.value)}
                  style={{ marginRight: 8 }}
                />
                <strong>Both (Recommended)</strong>
                <div style={{ fontSize: 11, color: '#6b7280', marginLeft: 20, marginTop: 2 }}>
                  Combination of statistical and judgmental approaches
                </div>
              </label>
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
              <button
                onClick={() => setShowModal(false)}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: '1px solid #d1d5db',
                  background: 'white', cursor: 'pointer', fontSize: 13
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 6, border: 'none',
                  background: loading ? '#9ca3af' : '#ec4899', 
                  color: 'white', cursor: 'pointer',
                  fontWeight: 600, fontSize: 13
                }}
              >
                {loading ? 'Processing…' : 'Conduct Testing'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}